export default {
  install(Vue) {
    Vue.prototype.$gmt = function () {
      let gmt = new Date();
      gmt.getTimezoneOffset() / 60;
      let sub = String(gmt);
      sub = sub.slice(25, 33);
      return sub
    }
    Vue.prototype.$gmtShort = function () {
      let gmt = new Date();
      gmt.getTimezoneOffset() / 60;
      let sub = String(gmt);
      sub = sub.slice(28, 31);
      return sub
    }
    Vue.prototype.$gmtHour = function () {
      let gmt = new Date();
      gmt.getTimezoneOffset() / 60;
      let sub = String(gmt);
      sub = sub.slice(28, 31);
      let gmtHour = 23 + Number(sub);
      return gmtHour
    }
  }
}